export default __webpack_public_path__ + "static/Refreshments-138cd40b9bc8c821fd6d0a02af70caae.png";